import {Directive, effect, ElementRef, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AnimationBuilder, AnimationPlayer} from "@angular/animations";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {animerBlink} from "../../animasjoner";
import {erIkkeTomStreng} from "felles-ng2/støttefunksjoner/strenger";

const debug = initDebugger('BlinkKomponent');

/**
 * Direktiv som blinker når angitt verdi endres (til noe annet enn null).
 * Tips, bruk feks Temporal.Now.instant() som verdi til blinkElement for å sikre unike verdier og trigging av animasjon.
 *
 * Eks: `<div [blinkElement]="nårDenneLevererIkkeNullVerdiBlinkerElementet()">...</div>`
 * eller `<div blinkElement #blinkDirektiv="blink">...</div> ... <a (click)="blinkDirektiv.blink()">klikk for å blinke</a>`
 */
@Directive({
    selector: '[blinkElement]',
    exportAs: 'blink',
    standalone: true
})
export class BlinkElementDirektiv {

    /** Når denne input-verdien endrer (til noe annet enn null) seg blinker vi elementet direktivene */
    blinkTrigger = input<any>(null, {alias: 'blinkElement'});

    private blinkAnimasjon: AnimationPlayer;

    constructor(private elementRef: ElementRef, private animationBuilder: AnimationBuilder) {
        this.blinkAnimasjon = this.animationBuilder.build(animerBlink()).create(this.elementRef.nativeElement);

        //kjører animasjon når this.blink() endrer verdi (til annet enn null)
        effect(() => {
            const triggerverdi = this.blinkTrigger();
            //ved angulars initielle kjøring av effect har blinkTrigger verdien ''...
            if(erIkkeNil(triggerverdi) && erIkkeTomStreng(triggerverdi)) this.blink();
        });
    }

    blink() {
        this.blinkAnimasjon.restart();
    }
}
